import { render, staticRenderFns } from "./NoteAndChatSP.vue?vue&type=template&id=0351f1dd&scoped=true&"
import script from "./NoteAndChatSP.vue?vue&type=script&lang=js&"
export * from "./NoteAndChatSP.vue?vue&type=script&lang=js&"
import style0 from "./NoteAndChatSP.vue?vue&type=style&index=0&id=0351f1dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351f1dd",
  null
  
)

export default component.exports